import { Collapse, Image, Typography } from 'antd';
import PageTopBar from 'components/navigation/PageTopBar';
import { colors, radius } from 'design';
import { supportEmail } from 'locales/fr/translation';
import { Trans, useTranslation } from 'react-i18next';
import { createUseStyles } from 'react-jss';
import { Link } from 'react-router-dom';

const { Title } = Typography;

const panelStyle: React.CSSProperties = {
  marginBottom: 24,
  background: colors.surface.base,
  border: 'none',
};

const data = [
  {
    key: '1',
    label: 'Quelles questions puis-je poser sur Gynger ?',
    children: (
      <div>
        <p>
          🤔 “Qui dois-je consulter pour… ?” “Est-ce que c’est normal que je … ?” “Qu’est-ce ça veut dire … ?” “Que
          faire si je me sens… ?”…
        </p>
        <p>Posez votre question sur Gynger, un soignant vous répondra rapidement !</p>
        <p>
          🧑‍⚕️ Gynger est la messagerie gynécologique pour toutes! Derrière celle-ci, nous avons mobilisé des
          professionnels de santé et des thérapeutes avec des expertises complémentaires et variées. Notre objectif est
          qu'avec Gynger vous soyez informée, accompagnée et orientée selon vos besoins.
        </p>
        <p>
          🙌 Vous pouvez donc poser toutes vos questions de santé féminine qui vous préoccupent, d'une simple recherche
          d'information à l'attente d'un avis médical, nous sommes à votre écoute.
        </p>
      </div>
    ),
    style: panelStyle,
  },
  {
    key: '5',
    label: "Est-ce que mon employeur / ma mutuelle sait que j'utilise Gynger ?",
    children: (
      <div>
        <p>Non 🌞</p>
        <p>
          Si vous avez créé un compte avec un code partenaire, votre employeur / votre mutuelle ne sait pas que vous
          utilisez Gynger et n'a aucun accès à vos données sur l'application. Les conversations comme vos données
          présentes sur l'applications sont strictement confidentielles.
        </p>
        <p>Vos données sont bien entendu tout aussi confidentielles si vous avez créé un compte gratuit.</p>
      </div>
    ),
    style: panelStyle,
  },
  {
    key: '6',
    label: 'Qui a accès aux conversations que je mène sur Gynger ?',
    children: (
      <div>
        <p>
          Vos conversations sont accessibles uniquement par vous et par l'équipe de soignants avec qui vous communiquez.
          Chaque membre de notre équipe de soins est tenu au secret médical ou secret professionnel, vos conversations
          sont donc strictement confidentielles.
        </p>
      </div>
    ),
    style: panelStyle,
  },
  {
    key: '7',
    label: 'Puis-je utiliser Gynger alors que je n’ai aucune pathologie ou que je ne suis pas une femme ?',
    children: (
      <div>
        <p>
          Bien sûr 🌻 Gynger s’adresse à tout.e.s celles et ceux qui souhaitent être informé.e.s, accompagné.e.s et
          orienté.e.s dans leur parcours de soins ou celui de leur proche. Nos soignants sont spécialisés en santé
          féminine et apporteront des réponses bienveillantes à tout.e.s !
        </p>
      </div>
    ),
    style: panelStyle,
  },
  {
    key: '8',
    label: 'Puis-je avoir confiance dans les experts de Gynger ?',
    children: (
      <div>
        <ul style={{ paddingInlineStart: '12px' }}>
          <li>
            Gynger a pris soin de sélectionner des professionnels de santé et des thérapeutes formés spécifiquement aux
            problématiques de santé féminine que vous pouvez rencontrer,
          </li>
        </ul>
        <p />
        <ul style={{ paddingInlineStart: '12px' }}>
          <li>
            Chacun d'eux s'est engagé à respecter notre charte de bienveillance et sera à votre écoute pour que vous
            vous sentiez au mieux,
          </li>
        </ul>
        <p />
        <ul style={{ paddingInlineStart: '12px' }}>
          <li>La messagerie Gynger a un taux de satisfaction supérieur à 95% auprès des premières utilisatrices!</li>
        </ul>
      </div>
    ),
    style: panelStyle,
  },
  {
    key: '9',
    label: 'Est-ce que Gynger remplace une consultation médicale ?',
    children: (
      <div>
        <p>
          L’accompagnement par chat proposé par Gynger est complémentaire à la consultation physique, et ne vient en
          aucun cas la remplacer. En cas d’urgence, appelez le 15 ! ☎️
        </p>
      </div>
    ),
    style: panelStyle,
  },
  {
    key: '11',
    label: 'Est-ce que mes données personnelles sont en sécurité ?',
    children: (
      <div>
        <ul style={{ paddingInlineStart: '12px' }}>
          <li>
            L'application Gynger et vos données personnelles sont hébergées sur un serveur agréé Hébergeur de Données de
            Santé par le Ministère de la Santé et nous respectons minutieusement la loi sur le Règlement Général de
            Protection des Données.
          </li>
        </ul>
        <ul style={{ paddingInlineStart: '12px' }}>
          <li>
            Aussi, grâce à l’expertise de son équipe technique, Gynger a pris soin de mettre en place des procédures qui
            garantissent la sécurité de vos données de bout en bout.
          </li>
        </ul>
      </div>
    ),
    style: panelStyle,
  },
];

const useStyles = createUseStyles({
  pageContainer: {
    height: '100%',
    display: 'flex',
    flexDirection: 'column',
    overflowY: 'scroll',
  },
  container: {
    padding: 8,
    height: '100%',
    overflowY: 'scroll',
    backgroundColor: colors.surface.page,
  },
  title: {
    color: colors.brand.accentStrong,
  },
  video: {
    marginTop: 20,
    border: 'none',
  },
  iconContainer: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'center',
    gap: '20px',
  },
  supportParagraph: {
    marginTop: 32,
    marginBottom: 64,
    textAlign: 'center',
    color: colors.text.tertiary,
  },
  collapse: {
    // The app's `Collapse` theme (`antdTheme.ts`) zeroes horizontal padding
    // on the header and content by design, for the common case: a collapse
    // used as a quiet in-page divider inside a card that already has its own
    // padding. This page's items are the opposite — each one *is* the card,
    // with its own background and radius — so it has no ancestor padding to
    // borrow and has to supply its own.
    // `!important`: antd's own accordion styling only rounds the *outer*
    // corners of the first and last item (`:first-child`/`:last-child`, top
    // only / bottom only) so a seamless stack reads as one rounded block.
    // These items are separate cards (`marginBottom: 24` apart), not a
    // seamless stack, and that selector ties our specificity and wins the
    // cascade — leaving the first item's bottom corners and the last item's
    // top corners square.
    '& .ant-collapse-item': {
      borderRadius: `${radius.lg}px !important`,
      paddingLeft: 16,
      paddingRight: 16,
      backgroundColor: 'white',
    },
  },
});

export default function FaqPage() {
  // Hooks
  const styles = useStyles();
  const { t } = useTranslation();

  return (
    <div className={styles.pageContainer}>
      <PageTopBar title={t('appName')} />

      <div className={styles.container}>
        <br />

        <Title level={4} className={styles.title}>
          {t('faq.networks')}
        </Title>

        <div className={styles.iconContainer}>
          <Link to={t('social.instagram')} target="_blank" rel="noopener noreferrer">
            <Image
              alt="social-instagram"
              height={50}
              width={50}
              preview={false}
              src={require('../assets/social-instagram.png')}
            />
          </Link>
          <Link to={t('social.linkedIn')} target="_blank" rel="noopener noreferrer">
            <Image
              alt="social-linkedIn"
              height={50}
              width={50}
              preview={false}
              src={require('../assets/social-linkedin.png')}
            />
          </Link>
        </div>

        <Title level={4} className={styles.title}>
          {t('faq.questions')}
        </Title>

        <Collapse bordered={false} items={data} ghost className={styles.collapse} />

        <p className={styles.supportParagraph}>
          <Trans
            i18nKey="settings.supportParagraph"
            components={{ a: <Link to={`mailto:${supportEmail}`} />, br: <br /> }}
          />
        </p>
      </div>
    </div>
  );
}
